import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-wa-stack',
	templateUrl:'./WaStackPluginCompPage.html',
	styles: [],
	styleUrls:['./WaStackPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaStackPluginCompPage
{
	mdContent_1144 = `\`\`\`java
import com.jwebmp.webawesome.components.WaStack;
\`\`\``;
	mdContent_1145 = `\`\`\`java
new WaStack&lt;&gt;()
\`\`\``;
}
